import { GdClientModule } from '@glidecms/deliver-core-dev/gd-module/gd-client-module.decorator'

@GdClientModule({
  declarations: [
    {
      name: 'MasterLayout',
      eager: true,
      mod: require(/* webpackChunkName: 'MasterLayout' */ /* webpackMode: 'eager' */ './master-layout/master-layout.component'),
      load: () =>
        Promise.resolve(
          require(/* webpackChunkName: 'MasterLayout' */ /* webpackMode: 'eager' */ './master-layout/master-layout.component')
        ),
    },
  ],
})
export class SharedModule {}
